/**
 * Contact Us service (public landing page).
 *
 * Talks to the public, unauthenticated `/api/v1/contact` endpoint — no JWT
 * is attached (any visitor, logged in or not, can submit an enquiry). Uses
 * the same shared `api` Axios instance as every other service so requests
 * still resolve against `VITE_API_BASE_URL`; the interceptor's token
 * attachment is a no-op here since there's nothing in storage for
 * anonymous visitors.
 */

import api from "@/services/api";

export interface ContactFormValues {
  full_name: string;
  email: string;
  mobile?: string;
  company_name?: string;
  subject?: string;
  message: string;
}

export interface ContactResponse {
  message: string;
}

export const contactService = {
  async submitEnquiry(values: ContactFormValues): Promise<ContactResponse> {
    const { data } = await api.post<ContactResponse>("/contact", values);
    return data;
  },
};

export default contactService;
